'use client';
import React from 'react';
import { useEffect, useRef, useState } from "react"
import Wrapper from "../shared/Wrapper.jsx"
import { PiCloudArrowUp } from "react-icons/pi";

// Handler needs to create a hidden upload button

function MioFile(p) {
    const fileRef = useRef();
    const [placeholder, setPlaceholder] = useState('');

    useEffect(() => {
        setPlaceholder(p.multiple ? 'Select file(s)' : 'Select file')
    }, [p.multiple])

    const clickHandler = (event) => {
        event.preventDefault();
        event.stopPropagation();
        console.log('hey');
        fileRef.current.click();
    }

    const fileHandler = (event) => {
        if (!event.target.files) {
            setPlaceholder('No file selected!');
            return null;
        }
        const file = event.target.files[0];
        setPlaceholder(`File: ${file.name}`)
        if (!p.formData) return p.file(file);
        if (p.formData) {
            const formData = new FormData();
            formData.append(`files`, file);
            return p.file(formData);
        }


    }


    return (
        <>
            <Wrapper {...p}>
                <div className="mtwi">
                    <input
                        type="file"
                        ref={fileRef}
                        onChange={fileHandler}
                        multiple={!!p.multiple}
                        style={{ display: 'none' }}
                    />
                    <input
                        className="mio-form-control-input mio-form-control-file"
                        type="text"
                        onMouseDown={clickHandler} onFocus={clickHandler}
                        placeholder={placeholder}
                    />
                    <div className="mio-form-control-icon" onClick={clickHandler}>
                        <PiCloudArrowUp />
                    </div>
                </div>
            </Wrapper>
        </>
    )
}
export default MioFile